import { faqIntro, faqs } from "@/content/faq";
import { Accordion } from "@/components/ui/Accordion";
import { GlobalCTA } from "@/components/ui/CTA";
import { PageHero } from "@/components/ui/PageHero";
import { Section } from "@/components/ui/Section";

export default function FaqPage() {
  return (
    <>
      <PageHero eyebrow="FAQ" title="Agentic Plus questions and answers" description={faqIntro} />

      <Section title="Product, governance, and roadmap answers" tone="surface">
        <Accordion
          items={faqs.map((faq) => ({ id: faq.id, question: faq.question, answer: faq.answer }))}
        />
      </Section>

      <Section
        title="Need a specific answer?"
        lead="Security, procurement, agency, and integration questions often need more context than a general FAQ can provide."
        tone="paper"
      >
        <div className="grid gap-6 md:grid-cols-3">
          {[
            {
              title: "Security reviews",
              description:
                "Ask about workspace isolation, permissions, audit, and provider handling.",
              href: "/security",
              label: "Read the security overview",
            },
            {
              title: "Agency rollout",
              description: "Ask about client workspaces, brand context, and phased onboarding.",
              href: "/contact",
              label: "Contact the agency team",
            },
            {
              title: "Product scope",
              description: "Review available modules and the capabilities marked Planned.",
              href: "/product",
              label: "Review product scope",
            },
          ].map((item) => (
            <article key={item.title} className="surface-card p-6">
              <h3 className="text-xl font-bold">{item.title}</h3>
              <p className="mt-3 text-ink-soft">{item.description}</p>
              <a
                className="mt-4 inline-flex min-h-11 items-center font-bold text-brand-700 underline"
                href={item.href}
              >
                {item.label}
              </a>
            </article>
          ))}
        </div>
      </Section>

      <GlobalCTA />
    </>
  );
}
